import { render } from "./ColorPickerListHolder.vue?vue&type=template&id=0ee6e39e&scoped=true"
import script from "./ColorPickerListHolder.vue?vue&type=script&lang=js"
export * from "./ColorPickerListHolder.vue?vue&type=script&lang=js"

import "./ColorPickerListHolder.vue?vue&type=style&index=0&id=0ee6e39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee6e39e"]])

export default __exports__